export const getClientLabel = (client) => {
  if (!client) {
    return "The client";
  }

  if (client.first_name && client.last_name) {
    return `${client.first_name} ${client.last_name}`;
  }

  return client.username;
};

export const getParticipantEmail = (email) => {
  if (!email) {
    return "";
  }

  if (email.endsWith("@noemailprovided.com")) {
    return email.split("@")[0].slice(0, 20);
  }

  return email;
};

export const getFocusGroupStats = ({ participants = {}, revisions = {} }) => {
  const totalParticipants = Object.values(participants).reduce(
    (acc, curr) => acc + curr.length,
    0
  );
  const totalRevisions = Object.values(revisions).reduce(
    (acc, revs) => acc + revs.length,
    0
  );
  const totalVotes = Object.values(revisions).reduce(
    (acc, revs) =>
      acc + revs.reduce((acc2, rev) => acc2 + Object.keys(rev.votes).length, 0),
    0
  );

  return {
    totalParticipants,
    totalRevisions,
    totalVotes,
  };
};

export const getRevisionStats = ({ revision, group }) => {
  const votes = Object.values(revision.votes);
  const totalScores = votes.reduce(
    (acc, v) => acc + v.score * (group.weight_votes ? v.weight : 1),
    0
  );
  const totalWeight = votes.reduce(
    (acc, v) => acc + (group.weight_votes ? v.weight : 1),
    0
  );

  return {
    commentCount: votes.filter((v) => !!(v.comment || "").trim()).length,
    voteCount: votes.length,
    averageScore:
      totalWeight > 0 ? Math.round((totalScores / totalWeight) * 10) / 10 : 0,
  };
};
